<template>
  <section
    id="about"
    class="flex flex-col items-center justify-center bg-[#E5F6F1]"
  >
    <h2
      class="relative mx-10 mt-16 text-center text-[32px] font-bold uppercase"
    >
      O mně
      <span
        class="absolute bottom-[-35px] left-1/2 h-1 w-10 -translate-x-1/2 transform bg-primary"
      ></span>
    </h2>
    <div
      class="mx-10 my-20 flex max-w-2xl flex-col items-center justify-center gap-10 md:flex-row"
    >
      <img src="@/assets/brydlova-magdalena.png" data-aos="fade-right" data-aos-delay="500" alt="Magdaléna Brýdlová" />
      <p class="leading-6" data-aos="fade-left" data-aos-delay="500">
        Jmenuji se <span class="text-primary font-bold">Magdaléna Brýdlová</span>, jsem psychoterapeutka se sídlem ve Svitavách.

        Vystudovala jsem magisterský obor sociální pedagogika - etopedie a jsem absolventkou psychoterapeutické výcviku v Logoterapii a existenciální analýze.
        Mám dlouholeté zkušenosti v individuální terapii, párovém a rodinném poradenství.
        V současné době jsem ve <a href="https://institutparoveterapie.cz/adresar-parova-terapie/" target="_blank" class="text-primary">výcviku párové terapie (2025 - 2028)</a>.
        Věřím, že každý z nás může najít cestu k naplněnému životu, a ráda vás touto cestou provedu.
      </p>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped></style>
